/**
 * 
 * @param {Date} date 
 * @returns True if the date is today else false
 */
export function isToday(date) {
    const today = new Date();
    const isTodayRes = (today.toDateString() == new Date(date)?.toDateString());
    return isTodayRes;
}